<div class="phones-wrapper">
  <div class="list-container">
    <onsip-selection-list-deluxe
      [showMasterToggle]="false"
      [showSearchField]="false"
      class="phone-numbers-list"
      color="primary"
      disableRipple
      [formControl]="controlValue"
    >
      @if (phoneNumberList.length) { @for (phoneNumber of phoneNumberList; track phoneNumber) {
      <mat-list-option
        [value]="phoneNumber.id"
        checkboxPosition="before"
        [attr.data-cy]="E2eLocators.CONTROLS_PHONES_LIST_ITEM"
      >
        {{ phoneNumber.name | e164 }}
        {{ phoneNumber.assigned ? "(assigned)" : "" }}
      </mat-list-option>
      } } @else {
      <mat-list-item [disableRipple]="true">
        {{ "ONSIP_I18N.NO_PHONE_NUMBERS" | translate }}
      </mat-list-item>
      }
    </onsip-selection-list-deluxe>
  </div>
  <button
    mat-button
    color="primary"
    (click)="createAddNumberDialog()"
    type="button"
    class="add-button"
  >
    <mat-icon>add</mat-icon>
    {{ "ONSIP_I18N.ADD_NUMBER" | translate }}
  </button>
</div>
